'use strict';

angular.module('shiftTraderApp')
  .directive('saUserPictUpload', function () {
    return {
      restrict: 'A',
      scope: {
        action: '@',
        user: '=',
        loggedInUser:'='
      },
      controller: ['$scope', 'UserPermissionsService',  function ($scope, UserPermissionsService) {

        $scope.state = {
          rawPermissions: null,
          derivedPermissions: null
        };

        var permissionsToLookUp = [
          'users.change_my_avatar',
          'users.change_avatar'
        ];

        UserPermissionsService.getCanDict(permissionsToLookUp, 'current')
          .then(function(dikt) {
            $scope.state.rawPermissions = dikt;

            processRawPermissions();
          });

        function processRawPermissions() {
          var myProf = $scope.loggedInUser.id === $scope.user.id;
          var rawPerm = $scope.state.rawPermissions;

          $scope.state.derivedPermissions = {
            canChangeAvatar: (myProf && rawPerm['users.change_my_avatar'] || rawPerm['users.change_avatar'])
          };
        }


        $scope.progress = 0;
        $scope.avatar = '';
        $scope.avatar_url = $scope.user.avatar_urls.profile;

        $scope.removeProfileImage = function() {
          $scope.user.$update({
            user: { delete_avatar:1 }
          }).then(function(response) {
            $scope.user.avatar_urls = response.avatar_urls;
            $scope.user.avatar_updated_at = response.avatar_updated_at;
            $scope.avatar_url = response.avatar_urls.profile;
          });
        };

        $scope.sendFile = function(el) {
          var $form = $(el).parents('form');
          if ($(el).val() == '') {
            return false;
          }

          $form.attr('action', $scope.action);

          $scope.$apply(function() {
            $scope.progress = 0;
          });

          $form.ajaxSubmit({
            type: 'PUT',
            uploadProgress: function(event, position, total, percentComplete) {

              $scope.$apply(function() {
                // upload the progress bar during the upload
                $scope.progress = percentComplete;
              });

            },
            error: function(event, statusText, responseText, form) {
              // remove the action attribute from the form
              $form.removeAttr('action');
              console.log('whoops... we had an error!');
            },
            success: function(responseText, statusText, xhr, form) {
              // remove the action attribute from the form
              console.log('success');
              console.log(responseText);
              $form.removeAttr('action');

              $scope.$apply(function() {
                $scope.user.avatar_urls = responseText.avatar_urls;
                $scope.user.avatar_updated_at = responseText.avatar_updated_at;
                $scope.avatar = responseText.avatar_urls.profile;
                $scope.progress = 0;
              });
            }
          });
        };
      }],
      link: function(scope, elem) {
        elem.find('.fake-uploader').click(function() {
          elem.find('input[type="file"]').click();
        });
      },
      replace: false,
      templateUrl: 'views/directives/saUserPictUploader.html'
    };
  });
